import { useRef, useState } from "react";

/**
 * Every poll signs an image's link again, although the image is the same; a new link makes the
 * browser download it again. Keep the first link while `identity` names the same image, and take
 * the newest after `drop` (the kept one failed to load: it expired).
 */
export function useStableUrl(identity: string, url: string | null | undefined): [string | undefined, () => void] {
  const kept = useRef<{ identity: string; url: string } | null>(null);
  const failed = useRef<string | null>(null);
  const [, redraw] = useState(0);
  if (!url) kept.current = null;
  else if (kept.current?.identity !== identity) kept.current = url === failed.current ? null : { identity, url };
  const drop = () => {
    failed.current = kept.current?.url ?? null;
    kept.current = null;
    redraw((n) => n + 1);
  };
  return [kept.current?.url, drop];
}
